import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WithDynamicContent } from '@woolworthsnz/dynamic-content';
import {
	NotificationType,
	TrackingEvent,
	WithPageMeta,
	SvgIconComponent,
	TrackEventDirective,
} from '@woolworthsnz/styleguide';
import { OliveButtonComponent } from '../../components/olive-button/olive-button.component';

@WithPageMeta({ pageTitle: 'contactUs' })
@WithDynamicContent()
@Component({
	selector: 'wnz-contact-us',
	templateUrl: './contact-us.page.html',
	styleUrls: ['./contact-us.page.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [OliveButtonComponent, SvgIconComponent, TrackEventDirective],
})
export class ContactUsPage {
	notificationType = NotificationType;
	trackingEvent = TrackingEvent;
}
